import { useMutation, useQueryClient } from "@tanstack/react-query";
import { resourceReqService } from "./api/resourceReq";

export const useCreateResourceRequest = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ payload }: { payload: any }) => resourceReqService.createResourceReq(payload),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ["create-request"] });
    },
  });
};

export const useUpdateResourceRequest = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: any }) => resourceReqService.updateResourceReq(id, payload),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ["update-request"] });
    },
  });
};

export const useGetActivity = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ projectId, phaseId }: { projectId: string | undefined; phaseId: string }) =>
      resourceReqService.getActivitys(projectId, phaseId),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ["get-activity"] });
    },
  });
};

export const useDeleteResourceRequest = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id }: { id: string }) => resourceReqService.deleteResourceReq(id),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ["delete-request"] });
    },
  });
};